module.exports = __webpack_public_path__ + "img/feixinjiaju4.966983ff.jpg";